export default "__VITE_ASSET__BJmKA$ob__"